import {CustomerModel} from '..';

export class LoanActivityModel {
	event: string;
	date: string;
	time: string;
	doer: string;
}
